import { render, staticRenderFns } from "./editaddfee.vue?vue&type=template&id=1d5668d1"
import script from "./editaddfee.vue?vue&type=script&lang=js"
export * from "./editaddfee.vue?vue&type=script&lang=js"
import style0 from "./editaddfee.vue?vue&type=style&index=0&id=1d5668d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports